import { FiArrowLeft, FiUser, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { useState } from "react";
import ButtonDelAccount from "../Button/ButtonDelAccount";
import { Link } from "react-router-dom";

export default function DeleteAccount() {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="w-full min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-8">
        <div className="flex items-center gap-2 text-gray-700 mb-6">
          <Link to="/">
            <FiArrowLeft size={24} className="text-black hover:text-gray-500" />
          </Link>
          <h1 className="text-2xl font-bold">Xóa Tài Khoản</h1>
        </div>
        <form className="space-y-6">
          <div className="relative w-full">
            <span className="absolute inset-y-0 left-3 flex items-center text-gray-500">
              <FiUser size={18} />
            </span>
            <input
              type="text"
              placeholder="Tên đăng nhập"
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="relative w-full">
            <span className="absolute inset-y-0 left-3 flex items-center text-gray-500">
              <FiLock size={18} />
            </span>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Mật khẩu"
              className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="button"
              className="absolute inset-y-0 right-3 flex items-center text-gray-500"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
            </button>
          </div>

          <div className="flex items-center justify-center w-full">
            <ButtonDelAccount />
          </div>
        </form>
      </div>
    </div>
  );
}
